export function configObject(value) {
  if (value && typeof value === 'object' && !Array.isArray(value)) return value;
  if (!value) return {};
  const parsed = JSON.parse(value);
  if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) throw new Error('配置必须是 JSON 对象');
  return parsed;
}

export function seedance25ErrorMessage(error, fallback) {
  return error?.response?.data?.message || error?.message || fallback;
}

export function missingChannelTariffs(channels, capabilities, mode, options = []) {

  const problems = [];
  for (const channel of channels || []) {
    if (!channel?.enabled || !channel.accept_new_tasks || !channel.contract_verified) continue;
    const label = options.find(option => String(option.value) === String(channel.model_config_id))?.label || `渠道 ${channel.model_config_id || '未选择'}`;
    let tariff;
    try { tariff = configObject(channel.selling_prices); }
    catch (_) { problems.push(`${label}：售价配置格式有误`); continue; }
    let effective;
    try { effective=effectiveChannelCapabilities(capabilities,configObject(configObject(channel.settings).capabilities)); }
    catch (_) { problems.push(`${label}：渠道能力格式有误`); continue; }
    if(!hasEffectiveCapabilities(effective)) continue;
    const reference=(effective.supported_modes||[]).includes('full_reference') && effective.max_reference_videos>0;
    for (const resolution of effective.resolutions || []) {
      const valid = value => typeof value === 'number' && Number.isFinite(value) && value > 0 && value <= 1000000;
      if (!valid(tariff.resolution_pricing?.[resolution])) problems.push(`${label}：${resolution} 无参考视频售价未填写或无效`);
      if (reference && !valid(tariff.resolution_pricing_with_video?.[resolution])) problems.push(`${label}：${resolution} 有参考视频售价未填写或无效`);
      const bound = tariff.max_tokens_per_second?.[resolution];
      if (mode === 'supplier_token_bound' && (!Number.isInteger(bound) || bound <= 0 || bound > 1000000000)) problems.push(`${label}：${resolution} 每秒 Token 上限未填写或无效`);
    }
  }
  return problems;
}

export function updateCapabilityOptions(value, field, options) {
  if (!['supported_modes', 'resolutions', 'aspect_ratios', 'duration_range'].includes(field)) throw new Error('不支持的能力字段');
  return JSON.stringify({...configObject(value), [field]: options}, null, 2);
}

export function updateChannelTariff(value, resolution, field, amount) {
  if (!['resolution_pricing', 'resolution_pricing_with_video', 'max_tokens_per_second'].includes(field)) throw new Error('不支持的价格字段');
  const prices = configObject(value);
  const rates = {...prices[field]};
  if (amount == null) delete rates[resolution]; else rates[resolution] = amount;
  return JSON.stringify({...prices, [field]: rates}, null, 2);
}

export function channelOptions(providers, models) {
  return models.filter(model => /seedance.*2\.5/i.test(model.model_name || '')).map(model => {
    const provider = providers.find(row => String(row.id) === String(model.provider_id));
    return {
      value: model.id,
      label: `${provider?.display_name || provider?.name || '未命名渠道'} · ${model.display_name || model.model_name}`,
      model,
    };
  });
}

export function channelPrices(model) {
  const config = configObject(model.video_config);
  const source = config.public_prices ? configObject(config.public_prices) : config;
  const prices = {};
  for (const key of ['resolution_pricing', 'resolution_pricing_with_video', 'max_tokens_per_second']) {
    if (source[key] && typeof source[key] === 'object' && !Array.isArray(source[key])) prices[key] = source[key];
  }
  if (!prices.max_tokens_per_second && config.max_tokens_per_second) prices.max_tokens_per_second = config.max_tokens_per_second;
  const hasPrices = Object.keys(prices.resolution_pricing || {}).length > 0;
  // 成本只取显式成本配置，不能从普通 input_price 或售价推算。
  const cost = config.cost_prices ? configObject(config.cost_prices) : {};
  return { prices: hasPrices ? prices : null, cost, bounds: prices.max_tokens_per_second || {} };
}

// 保留已有扩展价格字段；表单输入优先，清空输入会删除对应项。
export function priceRows(prices = {}, capabilities = {}) {
  const resolutions = [...new Set([...(capabilities.resolutions || []), ...Object.keys(prices.resolution_pricing || {}), ...Object.keys(prices.resolution_pricing_with_video || {}), ...Object.keys(prices.max_tokens_per_second || {}), ...Object.keys(prices.reservation_policy?.output_cny_per_second || {}), ...Object.keys(prices.reservation_policy?.reference_cny_per_second || {}), ...Object.keys(prices.reservation_policy?.minimum_cny || {})])];
  return resolutions.map(resolution => ({resolution, normal: prices.resolution_pricing?.[resolution], withVideo: prices.resolution_pricing_with_video?.[resolution], bound: prices.max_tokens_per_second?.[resolution], reserveOutput:prices.reservation_policy?.output_cny_per_second?.[resolution], reserveReference:prices.reservation_policy?.reference_cny_per_second?.[resolution], reserveMinimum:prices.reservation_policy?.minimum_cny?.[resolution]}));
}
export function mergePriceRows(base, rows, policy) {
  const prices = {...base, resolution_pricing:{}, resolution_pricing_with_video:{}, max_tokens_per_second:{}};
  for (const row of rows || []) {
    if (row.normal != null) prices.resolution_pricing[row.resolution] = row.normal;
    if (row.withVideo != null) prices.resolution_pricing_with_video[row.resolution] = row.withVideo;
    if (row.bound != null) prices.max_tokens_per_second[row.resolution] = row.bound;
  }
  if (policy) {
    prices.reservation_policy={...policy, output_cny_per_second:{}, reference_cny_per_second:{}, minimum_cny:{}};
    for (const row of rows || []) {
      if (row.reserveOutput!=null) prices.reservation_policy.output_cny_per_second[row.resolution]=row.reserveOutput;
      if (row.reserveReference!=null) prices.reservation_policy.reference_cny_per_second[row.resolution]=row.reserveReference;
      if (row.reserveMinimum!=null) prices.reservation_policy.minimum_cny[row.resolution]=row.reserveMinimum;
    }
  }
  return prices;
}
export function reservationForm(prices) {
 return {mode:prices.reservation_policy?.mode || (Object.keys(prices.max_tokens_per_second || {}).length ? 'supplier_token_bound':'platform_per_second'),version:prices.reservation_policy?.version || (prices.reservation_policy || Object.keys(prices.max_tokens_per_second || {}).length ? '' : 'test-example-v1'),max_active_tasks_per_user:prices.reservation_policy?.max_active_tasks_per_user || 1};
}

// 平台测试示例，不是供应商报价或 Token 上限；仅补齐未配置的输入。
export function withReservationDefaults(rows, mode) {
  if (mode !== 'platform_per_second') return rows;
  return rows.map(row => ({...row,
    reserveOutput: row.reserveOutput ?? 0.2,
    reserveReference: row.reserveReference ?? 0.1,
    reserveMinimum: row.reserveMinimum ?? 1,
  }));
}

export function updateChannelCapability(value, field, next) {
  const settings = configObject(value);
  const capabilities = configObject(settings.capabilities);
  return JSON.stringify({...settings, capabilities: {...capabilities, [field]: next}}, null, 2);
}

export function channelCapabilityDifferences(pub, cap) {
  const issues = [];
  for (const [key, label] of [['supported_modes','生成模式'],['resolutions','分辨率'],['aspect_ratios','画面比例']]) {
    if (!Array.isArray(pub[key]) || !pub[key].length || !Array.isArray(cap[key]) || !cap[key].length) { issues.push(`${label}配置为空`); continue; }
    const missing = pub[key].filter(v => !cap[key].includes(v));
    if (missing.length) issues.push(`${label}不支持：${missing.join('、')}`);
  }
  const p = pub.duration_range, c = cap.duration_range;
  if (!Array.isArray(p) || !Array.isArray(c) || p.length !== 2 || c.length !== 2 || ![...p,...c].every(Number.isFinite)) issues.push('时长范围配置无效');
  else if (p[0] < c[0] || p[1] > c[1]) issues.push(`时长范围不覆盖：公开 ${p.join('–')} 秒，渠道 ${c.join('–')} 秒`);
  for (const [key,label] of [['max_reference_images','参考图片数量'],['max_reference_videos','参考视频数量'],['max_reference_audio','参考音频数量'],['max_reference_video_seconds','参考视频时长'],['max_reference_audio_seconds','参考音频时长']]) {
    if ((pub[key] || 0) > (cap[key] || 0)) issues.push(`${label}上限不足：公开 ${pub[key]}，渠道 ${cap[key] || 0}`);
  }
  for (const [key,label] of [['supports_auto_duration','自动时长'],['supports_audio_only','仅音频参考']]) if (pub[key] && !cap[key]) issues.push(`${label}不支持`);
  return issues;
}

// Opening policy is a saved allow-list, never recomputed on load or channel edits.
export function effectiveChannelCapabilities(policy, cap) {
  const out={...policy};
  for(const key of ['supported_modes','resolutions','aspect_ratios']) out[key]=(policy[key]||[]).filter(v=>(cap[key]||[]).includes(v));
  out.duration_range=[Math.max(policy.duration_range?.[0]||0,cap.duration_range?.[0]||0),Math.min(policy.duration_range?.[1]||0,cap.duration_range?.[1]||0)];
  for(const key of ['max_reference_images','max_reference_videos','max_reference_audio','max_reference_video_seconds','max_reference_audio_seconds']) out[key]=Math.min(policy[key]||0,cap[key]||0);
  for(const key of ['supports_auto_duration','supports_audio_only']) out[key]=!!policy[key]&&!!cap[key];
  return out;
}
export function hasEffectiveCapabilities(cap) {
 return ['supported_modes','resolutions','aspect_ratios'].every(k=>cap[k]?.length) && cap.duration_range?.[0]>0 && cap.duration_range[0]<=cap.duration_range[1];
}
export function openingPolicySnapshot(current, channels) {
 const caps=(channels||[]).filter(c=>c.enabled&&c.accept_new_tasks&&c.contract_verified).map(c=>configObject(configObject(c.settings).capabilities));
 if(!caps.length) throw new Error('请先配置至少一条已确认、启用且接收新任务的渠道');
 const result={...current};
 for(const key of ['supported_modes','resolutions','aspect_ratios']) result[key]=[...new Set(caps.flatMap(c=>c[key]||[]))];
 result.duration_range=[Math.min(...caps.map(c=>c.duration_range?.[0]||0)),Math.max(...caps.map(c=>c.duration_range?.[1]||0))];
 for(const key of ['max_reference_images','max_reference_videos','max_reference_audio','max_reference_video_seconds','max_reference_audio_seconds']) result[key]=Math.max(...caps.map(c=>c[key]||0));
 for(const key of ['supports_auto_duration','supports_audio_only']) result[key]=caps.some(c=>!!c[key]);
 if(!hasEffectiveCapabilities(result)) throw new Error('渠道能力不完整，请先补齐模式、分辨率、比例和时长');
 return result;
}

// Read-only aggregate. It is never an additional opening restriction.
export function channelOpeningSummary(channels) {
 const result={schema_version:'1.0.2',family:'seedance',enabled:true,capability_source:'channels-v1',supported_modes:[],resolutions:[],aspect_ratios:[],duration_range:[],output_formats:['mp4']};
 const live=(channels||[]).filter(c=>c.enabled&&c.accept_new_tasks&&c.contract_verified).map(c=>configObject(configObject(c.settings).capabilities)).filter(c=>c.enabled);
 for(const key of ['supported_modes','resolutions','aspect_ratios']) result[key]=[...new Set(live.flatMap(c=>c[key]||[]))];
 if(live.length) result.duration_range=[Math.min(...live.map(c=>c.duration_range?.[0]||0)),Math.max(...live.map(c=>c.duration_range?.[1]||0))];
 for(const key of ['max_reference_images','max_reference_videos','max_reference_audio','max_reference_video_seconds','max_reference_audio_seconds']) result[key]=Math.max(0,...live.map(c=>c[key]||0));
 for(const key of ['supports_auto_duration','supports_audio_only']) result[key]=live.some(c=>!!c[key]);
 return result;
}

// A selected mode must have usable inputs; never infer supplier limits from it.
export function channelMaterialProblems(cap = {}) {
 const modes=cap.supported_modes || [], issues=[];
 if(modes.includes('first_frame') && !(cap.max_reference_images>=1)) issues.push('图生视频（首帧）需要参考图片数量上限至少为 1');
 if(modes.includes('start_end_frames') && !(cap.max_reference_images>=2)) issues.push('首尾帧生视频需要参考图片数量上限至少为 2');
 if(modes.includes('full_reference')) {
  if(!(cap.max_reference_images>0 || cap.max_reference_videos>0 || (cap.supports_audio_only && cap.max_reference_audio>0))) issues.push('参考生视频需要开放参考图片或参考视频；仅音频参考需同时开启对应功能和数量上限');
  if(cap.max_reference_videos>0 && !(cap.max_reference_video_seconds>0)) issues.push('开放参考视频后需要填写大于 0 的参考视频时长上限');
  if(cap.max_reference_audio>0 && !(cap.max_reference_audio_seconds>0)) issues.push('开放参考音频后需要填写大于 0 的参考音频时长上限');
 }
 return issues;
}
